import React from "react";
import { Row, Col, Card } from "antd";

// import { MdDelete, MdModeEditOutline, MdEmail } from "react-icons/md";
// import { BiMobile } from "react-icons/bi";
// import { SiHomeassistantcommunitystore } from "react-icons/si";
// import RmxCover from "../../assets/images/distributors-banner.jpg";
import "./index.css";
export default function ManufacturePlantInfo({
  inputText,
  inputTitle,
  backgroundImage,
  ...props
}) {
  return (
    <Row justify="center">
      <Col
        xs={20}
        sm={20}
        md={20}
        lg={20}
        xl={22}
        className="rmx-card  rmx-title"
        style={{ height: "360px" }}
      >
        <Row justify="center" style={{ marginBottom: "20px" }}>
          <Col
            xl={24}
            xs={24}
            sm={24}
            md={24}
            lg={24}
            style={{
              backgroundImage: `url(${backgroundImage})`,
            }}
            className="rmx-plantinfo-img"
          ></Col>
          <Col span={24}>
            <h6 className="text-center rmx-name three-dot">{inputText}</h6>
            <p className="text-center rmx-text">{inputTitle}</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
